// Example locale file for English, give this to your locale team to translate

export const AG_GRID_LOCALE_FA = {
    // Set Filter
    selectAll: '(انتخاب همه)',
    selectAllSearchResults: '(انتخاب همه نتایج جستجو)',
    searchOoo: 'جستجو ...',
    blanks: '(خالی)',
    noMatches: 'موردی پیدا نشد',

    // Number Filter & Text Filter
    filterOoo: 'فیلتر ...',
    equals: 'برابر با',
    notEqual: 'مخالف با',
    empty: 'انتخاب',

    // Number Filter
    lessThan: 'کمتر از',
    greaterThan: 'بیشتر از',
    lessThanOrEqual: 'کمتر یا برابر با',
    greaterThanOrEqual: 'بیشتر یا برابر با',
    inRange: 'در محدوده‌ی',
    inRangeStart: 'از',
    inRangeEnd: 'تا',

    // Text Filter
    contains: 'حاوی',
    notContains: 'بدون',
    startsWith: 'شروع شود با',
    endsWith: 'پایان یابد با',

    // Date Filter
    dateFormatOoo: 'سال-ماه-روز',

    // Filter Conditions
    andCondition: 'و',
    orCondition: 'یا',

    // Filter Buttons
    applyFilter: 'اعمال',
    resetFilter: 'تنظیم مجدد',
    clearFilter: 'پاک کردن',
    cancelFilter: 'لغو',

    // Filter Titles
    textFilter: 'فیلتر متنی',
    numberFilter: 'فیلتر عددی',
    dateFilter: 'فیلتر تاریخ',
    setFilter: 'ثبت فیلتر',

    // Side Bar
    columns: 'ستون ها',
    filters: 'فیلتر ها',
    storage: 'حافظه',
    help: 'راهنما',

    // columns tool panel
    pivotMode: 'Pivot Mode',
    groups: 'گروه بندی رکورد‌ها',
    rowGroupColumnsEmptyMessage: 'رها کنید تا گروه بندی اعمال شود',
    values: 'مقادیر',
    valueColumnsEmptyMessage: 'رها کنید تا محاسبه شود',
    pivots: 'Column Labels',
    pivotColumnsEmptyMessage: 'Drag here to set column labels',

    // Header of the Default Group Column
    group: 'گروه',

    // Other
    loadingOoo: 'در حال بارگذاری...',
    noRowsToShow: 'رکوردی برای نمایش وجود ندارد',
    enabled: 'فعال کردن',

    // Menu
    pinColumn: 'پین ستون',
    pinLeft: 'به چپ پین کن',
    pinRight: 'به راست پین کن',
    noPin: 'پین نکن',
    valueAggregation: 'Value Aggregation',
    autosizeThisColumn: 'اندازه این ستون را خودکار کن',
    autosizeAllColumns: 'اندازه همه ستون‌ها را خودکار کن',
    groupBy: 'دسته بندی بر اساس',
    ungroupBy: 'حذف دسته بندی',
    resetColumns: 'تنظیم مجدد ستون‌ها',
    expandAll: 'باز کردن همه',
    collapseAll: 'بستن همه',
    copy: 'کپی',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'کپی همراه با عناوین',
    paste: 'پیست',
    ctrlV: 'Ctrl+V',
    export: 'خروجی',
    csvExport: 'خروجی CSV',
    excelExport: 'خروجی اکسل (.xlsx)',
    excelXmlExport: 'خروجی اکسل (.xml)',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'جمع کل',
    min: 'کمترین',
    max: 'بیشترین',
    none: 'هیچ کدام',
    count: 'تعداد',
    average: 'میانگین',
    filteredRows: 'فیلتر شده',
    selectedRows: 'انتخاب شده',
    totalRows: 'جمع رکورد‌ها',
    totalAndFilteredRows: 'رکورد‌ها',
    more: 'بیشتر',
    to: 'تا',
    of: 'از',
    page: 'صفحه',
    nextPage: 'صفحه بعد',
    lastPage: 'صفحه آخر',
    firstPage: 'صفحه اول',
    previousPage: 'صفحه قبل',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
    pivotChart: 'Pivot Chart',
    chartRange: 'Chart Range',

    columnChart: 'Column',
    groupedColumn: 'Grouped',
    stackedColumn: 'Stacked',
    normalizedColumn: '100% Stacked',

    barChart: 'Bar',
    groupedBar: 'Grouped',
    stackedBar: 'Stacked',
    normalizedBar: '100% Stacked',

    pieChart: 'Pie',
    pie: 'Pie',
    doughnut: 'Doughnut',

    line: 'Line',

    xyChart: 'X Y (Scatter)',
    scatter: 'Scatter',
    bubble: 'Bubble',

    areaChart: 'Area',
    area: 'Area',
    stackedArea: 'Stacked',
    normalizedArea: '100% Stacked',

    histogramChart: 'Histogram',

    // Charts
    pivotChartTitle: 'Pivot Chart',
    rangeChartTitle: 'Range Chart',
    settings: 'Settings',
    data: 'Data',
    format: 'Format',
    categories: 'Categories',
    defaultCategory: '(None)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Axis',
    navigator: 'Navigator',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automatic',
    category: 'Category',
    number: 'Number',
    time: 'Time',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Width',
    height: 'Height',
    length: 'Length',
    padding: 'Padding',
    spacing: 'Spacing',
    chart: 'Chart',
    title: 'Title',
    titlePlaceholder: 'Chart title - double click to edit',
    background: 'Background',
    font: 'Font',
    top: 'Top',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    labels: 'Labels',
    size: 'Size',
    minSize: 'Minimum Size',
    maxSize: 'Maximum Size',
    legend: 'Legend',
    position: 'Position',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemSpacing: 'Item Spacing',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    layoutHorizontalSpacing: 'Horizontal Spacing',
    layoutVerticalSpacing: 'Vertical Spacing',
    strokeWidth: 'Stroke Width',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    boldItalic: 'Bold Italic',
    predefined: 'Predefined',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin count',
    columnGroup: 'Column',
    barGroup: 'Bar',
    pieGroup: 'Pie',
    lineGroup: 'Line',
    scatterGroup: 'X Y (Scatter)',
    areaGroup: 'Area',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Grouped',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% Stacked',
    groupedBarTooltip: 'Grouped',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% Stacked',
    pieTooltip: 'Pie',
    doughnutTooltip: 'Doughnut',
    lineTooltip: 'Line',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histogram',
    noDataToChart: 'No data available to be charted.',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.'
};